import React from 'react'
import s from './styles/DigitalProfile.module.scss'
import AboutSection from '../../Blocks/AboutSection/AboutSection'
import { ReactComponent as FootballIcon } from 'assets/icons/football.svg'
import { ReactComponent as MedalIcon } from 'assets/icons/medal-simple.svg'
import { ReactComponent as BagIcon } from 'assets/icons/bag-clock.svg'
import { ReactComponent as BagLineIcon } from 'assets/icons/bag-line.svg'
import AcademicPerformance from '../../Blocks/AcademicPerformance/AcademicPerformance'
import DocumentsBlock from '../../Blocks/DocumentsBlock/DocumentsBlock'
import ProfileItemsSection from '../../Blocks/ProfileItemsSection/ProfileItemsSection'

const DigitalProfile = ({
	data: rawData,
	studentId,
	onOpenDocuments,
	isLoading = false,
	careerInterests = [],
}) => {
	const data = rawData || {}

	const {
		activities = [],
		experiences = [],
		schoolName = '',
		skipActivities = false,
		skipExperience = false,
	} = data || {}

	const activitiesItems = activities.map(item => {
		let description = item.experience || ''

		if (!description && skipActivities) {
			description =
				'No extracurricular activities added yet. This section can be updated later.'
		}

		return {
			id: item.id,
			title: item.name || '',
			subtitle: schoolName,
			period: item.duration ? `${item.duration} months` : '',
			description,
			tag: item.role || item.category || '',
		}
	})

	const experienceItems = experiences.map(item => {
		const baseDescription = [item.description, item.achievements]
			.filter(Boolean)
			.join(' ')

		let description = baseDescription

		if (!description && skipExperience) {
			description =
				'No work experience added yet. This section can be updated later.'
		}

		return {
			id: item.id,
			title: item.jobRole?.label || item.jobRole || '',
			subtitle: item.company || '',
			period: item.duration ? `${item.duration} months` : '',
			description,
			tag: item.type || 'Internship',
		}
	})

	return (
		<div className={s.wrap}>
			<div className={s.top}>
				<AboutSection
					data={data}
					isLoading={isLoading}
					careerInterests={careerInterests}
				/>
				<AcademicPerformance data={data} isLoading={isLoading} />
				<DocumentsBlock studentId={studentId} onViewAll={onOpenDocuments} />
			</div>

			<div className={s.bottom}>
				<ProfileItemsSection
					title="Extracurricular Activities"
					color="green"
					items={activitiesItems}
					headerIcon={<FootballIcon />}
					cardIcon={<MedalIcon />}
					emptyText="Student hasn't added any activities yet."
					isLoading={isLoading}
				/>
				<ProfileItemsSection
					title="Work Experience"
					color="orange"
					items={experienceItems}
					headerIcon={<BagIcon />}
					cardIcon={<BagLineIcon />}
					emptyText="Student hasn't added work experience yet."
					isLoading={isLoading}
				/>
			</div>
		</div>
	)
}

export default DigitalProfile
